<div class="calculations">
    <div *ngIf="employeeTimeOffType" class="main-container">
        <div class="top">
            <div class="title">
                <h5>{{employeeTimeOffType.timeOffType?.name}}</h5>
                <h6>{{employeeTimeOffType.timeOffPolicy?.name}}</h6>
            </div>
        </div>
        <div class="balance-container">
            <div class="label">
                <h6 appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeBalance">
                    {{ 'EmployeeTimeOffTypeBalance' | translate: {Default: "Balance"} }}
                </h6>
            </div>
            <div setColor="primaryColour" class="balance">
                <ng-container *ngIf="employeeTimeOffType.availableHours; else noAvailableHours">
                    <h3>{{employeeTimeOffType.availableHours | number:'1.2-2' }}</h3>
                </ng-container>
                <ng-template #noAvailableHours>
                    <h3>0</h3>
                </ng-template>
            </div>
            <div class="hours">
                <h6 appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeHours">
                    {{ 'Hours' | translate: {Default: "Hours"} }}
                </h6>
            </div>
        </div>
    </div>

    <mat-icon class="material-icons-outlined">arrow_forward_ios</mat-icon>

    <div *ngIf="employeeTimeOffType" class="main-container">
        <div class="top">
            <div class="title">
                <h5>Hours</h5>
                <h6>Available after approval</h6>
            </div>
        </div>
        <div class="balance-container">
            <div class="label">
                <h6 appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeBalance">
                    {{ 'EmployeeTimeOffTypeBalance' | translate: {Default: "Balance"} }}
                </h6>
            </div>
            <div setColor="primaryColour" class="balance">
                <h3>
                    {{
                    (
                    selectedType === 'BUY'
                    ? employeeTimeOffType.availableHours + hoursInput
                    : employeeTimeOffType.availableHours - hoursInput
                    ) | number:'1.2-2'
                    }}
                </h3>
            </div>
            <div class="hours">
                <h6 appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeHours">
                    {{ 'Hours' | translate: {Default: "Hours"} }}
                </h6>
            </div>
        </div>
        <div class="carry-over-details">
            <div class="row" *ngIf="selectedType && hoursInput">
                <span appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeCarryOverAmount">
                    {{ selectedType === 'BUY' ? 'Salary Deduction' : 'Salary Addition' }} :
                </span>
                <span>
                    {{ compensation?.payRateCurrency?.id | currencyDisplay: hoursInput * buySellPlanEmployee?.hourlyCost }}
                </span>
            </div>
        </div>
    </div>
</div>